import { FORMAT_PRESETS } from './formatPresets';

export { FORMAT_PRESETS, FORMAT_PRESET_GROUPS, MIN_OUTPUT_EDGE, MAX_OUTPUT_EDGE } from './formatPresets';
export {
  SYSTEM_FONTS,
  FONT_FILE_ACCEPT,
  DEFAULT_TEXT_SHADOW,
  DEFAULT_TEXT_OUTLINE,
  DEFAULT_TEXT_BACKGROUND,
  addCustomFont,
  removeCustomFont,
  getFontStack,
  getFontLabel,
  getScaledTextDefaults,
  useCustomFonts,
  useBrandFonts,
  setBrandFonts,
  BRAND_FONT_ID_PREFIX,
  useFontsVersion,
} from './fonts';
export { TEXT_QUICK_ADD, TEXT_LOOKS, TEXT_BLOCKS, buildTextStyleOptions } from './textStyles';
export { DEFAULT_BRAND_COLORS } from './brandKit';
export { SHAPE_KINDS, SHAPE_GROUPS, DEFAULT_SHAPE, ARROW_HEAD_RATIO, isLineShape } from './shapes';
export {
  AI_LABEL_KINDS,
  AI_LABEL_VARIANTS,
  AI_LABEL_SIZES,
  AI_LABEL_CORNERS,
  DEFAULT_AI_LABEL_OPTIONS,
  createAiLabelPlacement,
} from './aiLabels';

export const TOOLS = {
  SELECT: 'select',
  HAND: 'hand',
  CROP: 'crop',
};

export const MEDIA_STUDIO_LAYOUT = {
  PAGE: 'page',
  EMBEDDED: 'embedded',
};

export const LAYOUT_BREAKPOINTS = {
  TABLET: 1279,
  COMPACT: 1023,
  MOBILE: 767,
};

export const SIDE_PANELS = {
  UPLOAD: 'upload',
  TEMPLATES: 'templates',
  AI_LABELS: 'aiLabels',
  TEXT: 'text',
  ELEMENTS: 'elements',
  FORMATS: 'formats',
  LAYERS: 'layers',
};

export const DEFAULT_MEDIA_STUDIO_FEATURES = {
  openImage: true,
  addLayer: true,
  layersPanel: true,
  formatPresets: true,
  download: true,
  reset: true,
  undoRedo: true,
  transform: true,
  opacityBlend: true,
  guides: true,
  align: true,
  sidePanel: true,
  inspector: true,
  zoomPan: true,
  grid: true,
  filters: true,
  flip: true,
  aspectLock: true,
  text: true,
  shapes: true,
  brandColors: true,
  brandImages: true,
  brandFonts: true,
  aiLabels: true,
  multiSelect: true,
  duplicate: true,
};

export const BLEND_MODES = [
  { id: 'source-over', labelKey: 'blendNormal' },
  { id: 'multiply', labelKey: 'blendMultiply' },
  { id: 'screen', labelKey: 'blendScreen' },
  { id: 'overlay', labelKey: 'blendOverlay' },
  { id: 'darken', labelKey: 'blendDarken' },
  { id: 'lighten', labelKey: 'blendLighten' },
];

export const DEFAULT_FILTERS = {
  blur: 0,
  brightness: 0,
  contrast: 0,
  saturation: 0,
  temperature: 0,
};

export const DEFAULT_ELEMENT_STYLE = {
  opacity: 1,
  blendMode: 'source-over',
  scaleX: 1,
  scaleY: 1,
  rotation: 0,
  keepAspectRatio: true,
  filters: { ...DEFAULT_FILTERS },
};

const DEFAULT_GRID_SIZE = 16;

export const DEFAULT_MEDIA_STUDIO_CONFIG = {
  tools: [TOOLS.SELECT, TOOLS.HAND],
  features: DEFAULT_MEDIA_STUDIO_FEATURES,
  panels: [
    SIDE_PANELS.LAYERS,
    SIDE_PANELS.FORMATS,
    SIDE_PANELS.TEXT,
    SIDE_PANELS.ELEMENTS,
    SIDE_PANELS.UPLOAD,
    SIDE_PANELS.TEMPLATES,
    SIDE_PANELS.AI_LABELS,
  ],
  formatPresets: FORMAT_PRESETS,
  initialImage: null,
  layout: MEDIA_STUDIO_LAYOUT.PAGE,
  gridSize: DEFAULT_GRID_SIZE,
};

export const FULL_MEDIA_STUDIO_CONFIG = DEFAULT_MEDIA_STUDIO_CONFIG;

export const mergeMediaStudioConfig = (config = {}) => {
  const features = {
    ...DEFAULT_MEDIA_STUDIO_FEATURES,
    ...(config.features || {}),
  };

  return {
    ...DEFAULT_MEDIA_STUDIO_CONFIG,
    ...config,
    features,
    tools: config.tools ?? DEFAULT_MEDIA_STUDIO_CONFIG.tools,
    panels: config.panels ?? DEFAULT_MEDIA_STUDIO_CONFIG.panels,
    formatPresets: config.formatPresets ?? DEFAULT_MEDIA_STUDIO_CONFIG.formatPresets,
    gridSize: config.gridSize ?? DEFAULT_MEDIA_STUDIO_CONFIG.gridSize,
  };
};

export { ASPECT_RATIOS, ASPECT_RATIO_OPTIONS, getAspectRatioValue, getInitialCropRect } from '../utils/aspectRatio';
